import React, { useEffect, useState } from 'react'

export const Odontology = (props) => {

  const [treatments, setTreatments] = useState([]);

  useEffect(() => {
    console.log('props', props);

    if (props.data?.wOdontogram?.treatments) {
      setTreatments(JSON.parse(props.data.wOdontogram.treatments));
    }

  }, [props]);

  // Helper function to format treatment display
  const formatTreatment = (treatment) => {
    console.log('treatment', treatment);
    
    let color = '#CCC';
    let label = 'P';

    if (treatment.tratamiento) {
      label += `${treatment.diente.id}`;
    }
    if (treatment.cara) {
      label += treatment.cara;
    }
    if (treatment.tratamiento) {
      label += ` | ${treatment.tratamiento.text}`;
      color = treatment.tratamiento.color_hex || treatment.tratamiento.color || '#CCC';
    }
    if (treatment.date) {
      label += ` | ${treatment.date}`;
    }

    return `<span style="color: ${color};"><small>${label}</small></span>`;
  };

  return (
    <div className="odontology-container mb-4">
      { treatments.length > 0 && (
        <div className="treatments-section">
          <h2 className="text-xl font-semibold mb-3">Detalle de tratamientos</h2>
          <div className="treatments-list space-y-1 py-1 bg-gray-50 rounded-xs border border-gray-200">
            {
              treatments.map((item, index) => (
                <div 
                  key={`treatment_${item.id || index}`}
                  className="treatment-item px-2"
                >
                  <div dangerouslySetInnerHTML={{ __html: formatTreatment(item) }} />
                </div>
              ))
            }
          </div>
        </div>
      )}      
    </div>
  )
}
